// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\">Beware of \"Debt Relief\" Organizations</h1> <p>Never pay for assistance with your private or federal student loans&mdash;your servicer provides assistance for free!</p> ";
// Exports
export default code;